import type { CVRParticipant } from '../types'

/**
 * Stable React list key for a participant row. `enhedsNummer` alone is
 * not unique — the same person can appear multiple times with different
 * role periods (historic direktion, etc.).
 */
export function participantRowKey(
  prefix: string,
  p: CVRParticipant,
  index: number
): string {
  return `${prefix}-${index}-${p.enhedsNummer ?? 'n'}-${p.role.validFrom ?? ''}-${p.role.validTo ?? ''}-${p.role.organizationType}`
}
